import React from "react";
import Hex from "../assets/sloth/sloth_conv.png"
import { Fade, Flip } from "react-awesome-reveal";



const Mission = () => {
    return(
        <section>
            <div className="container-theme flex items-center flex-col text-center text-[#0D3727] pt-[40px] lg:pt-[100px]">
               <Fade cascade duration={300}>
                <h2 className="h3 uppercase">
                    Our Mission
                </h2>
                <div className="grid lg:grid-cols-5 pt-[30px] lg:pt-[95px] lg:gap-[70px] relative">
            <div className='lg:col-span-3 text-left h-full flex justify-center flex-col'>
                <p className="body-1">
                    <strong>
                    The Sloth Conservation Foundation (SloCo) is a charity dedicated to saving sloths in the wild through research and conservation initiatives.
</strong>
<br/><br/>
The goal was to to donate 5% from the pre-sale and public sale, as well as 0.5% of the royalty income to help their cause.</p>

</div>
<div className="lg:col-span-2 lg:order-first pt-[30px] lg:pt-0">
                <Flip>
                <img src={Hex} className='w-1/2 mx-auto lg:w-full aspect-square'/>
                </Flip>
            </div>

        </div>
        </Fade>
            </div>                    
        </section>
    )
}

export default Mission